import {getInstitutionId} from "../app/utilities/helpers.functions";
const institution = getInstitutionId('uat');

export const environment = {
    type: 'uat',
    production: false,
    institutionCode: institution.institutionId,
    cxUrl: institution.cxUrl,
    s3Url: 'https://creditsnap-public-uat.s3.amazonaws.com/',
    debug: false,
    apiUrl:'https://demob2bapi.creditsnap.com/csb2b/',
    auth: {
        basic: 'Basic Y3NfdHJ1c3RlZF9jbGllbnQ6eHlzckdlN0dvdzJkZWZn',
        scope: 'read write trust',
        grantType: 'password',
        interceptorSkipHeader: 'X-Skip-Interceptor'
    },
};
